// extracted by mini-css-extract-plugin
export default {"bulk-adicionar-verba-button":"BulkAdicionarVerbaButton_bulk-adicionar-verba-button__eGZXl"};